// @flow

import { InMemoryCache, defaultDataIdFromObject } from "@apollo/client";

function dataIdFromObject(obj) {
  switch (obj.__typename) {
    case 'IntlMessage':
      // Do not use id as identifier for message because it's not unique between languages
      // instead instruct cache to build path and index identifier for cache key
      return null;
    case 'NewsItem':
      return obj.link ? `NewsItem:${obj.link}` : defaultDataIdFromObject(obj);
    case 'userProfile':
      // Use profileId as the cache key for userProfile to ensure consistency
      return obj.profileId ? `userProfile:${obj.profileId}` : defaultDataIdFromObject(obj);
    default:
      return defaultDataIdFromObject(obj);
  }
}

export default function createCache() {
  // https://www.apollographql.com/docs/react/basics/caching.html#configuration
  return new InMemoryCache({
    dataIdFromObject,
    typePolicies: {
      userProfile: {
        keyFields: ["profileId"],
        fields: {
          isMigrated: {
            merge(existing, incoming) {
              // Always prefer incoming value from server over cached value
              return incoming !== undefined ? incoming : (existing ?? false);
            }
          }
        }
      }
    }
  });
}
